import { atom } from "nanostores";
import { Session } from "@/store/types";

export const session = atom<Session | null>(null);

export const setSession = (data: Session) => {
  session.set(data);
};

export const clearStore = () => {
  session.set(null);
};
